import { render, staticRenderFns } from "./PremiosPromocao.vue?vue&type=template&id=065a5a22"
import script from "./PremiosPromocao.vue?vue&type=script&lang=ts"
export * from "./PremiosPromocao.vue?vue&type=script&lang=ts"
import style0 from "./PremiosPromocao.vue?vue&type=style&index=0&id=065a5a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports